module.exports = __webpack_public_path__ + "static/media/about-india.2d4b23f3.jpg";